import type { MemoryDreamingRunView, MemoryMaintenanceJob, MemoryMaintenanceState } from './types';
import type { LocaleDict } from './i18n/types';

/** History and the operation dock use the same localized host abort causes. Other failures retain their diagnostic text. */
export function memoryDreamingSummary(run: MemoryDreamingRunView, causes: LocaleDict['accountMemory']['dreaming']['abortCause']): string | null {
  if (!run.error) return run.summary;
  if (run.error === 'no_progress') return causes.noProgress;
  const [status, cause] = run.error.split(': ', 2);
  if (status !== 'aborted' && status !== 'interrupted') return run.error;
  switch (cause) {
    case 'user': case 'user_stop': return causes.user;
    case 'disabled': return causes.disabled;
    case 'account_deleted': return causes.accountDeleted;
    case 'daemon_pause': return causes.daemonPause;
    case 'parent_teardown': return causes.parentTeardown;
    case 'tree_abort': return causes.treeAbort;
    case 'recovery': return causes.recovery;
    default: return run.error;
  }
}

export interface MemoryDockOperation {
  kind: 'memory-maintenance';
  id: string;
  status: 'running' | 'succeeded' | 'failed';
  percent: number | null;
  job: MemoryMaintenanceJob;
}

/** The owner-scoped maintenance response already bounds and retains these durable runs. */
export function memoryDockOperations(state: MemoryMaintenanceState | undefined): MemoryDockOperation[] {
  return (state?.runs ?? []).map(job => ({
      kind: 'memory-maintenance', id: `memory:${job.id}`, job,
      status: job.status === 'running' ? 'running' : job.status === 'done' && job.failed === 0 ? 'succeeded' : 'failed',
      percent: job.total > 0 ? Math.round(job.processed / job.total * 100) : null,
    }));
}
